import React from 'react';

import { noop } from 'lodash';

import IconButton from '~/core/atoms/Buttons/IconButton';
import ClipIcon from '~/core/iconComponents/icons/ClipIcon';
import CloseIcon from '~/core/iconComponents/icons/CloseIcon';
import { UploadedFile } from '~/core/molecules/FileUpload/FileUploadModal';
import cn from '~/utils/cn';

interface UploadedFilesPanelProps {
  uploadedFiles: UploadedFile[];
  onRemove: (file: UploadedFile) => void;
  className?: string;
  disabled?: boolean;
}

export const UploadedFilesPanel: React.FC<UploadedFilesPanelProps> = ({
  uploadedFiles = [],
  onRemove = noop,
  className,
  disabled = false,
}) => {
  return (
    <div className={cn('bg-gradient-1', className)}>
      <ul className="flex flex-col gap-4">
        {uploadedFiles.map((item) => (
          <li
            key={item.url}
            className="text-grey-500 flex items-center gap-8 rounded-full py-0 text-sm hover:bg-black/2"
          >
            <ClipIcon className="min-w-24 rounded-full bg-white p-4" size={22} />
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="overflow-hidden text-ellipsis whitespace-nowrap text-blue-600 hover:underline"
              title={item.name}
            >
              {item.name}
            </a>
            <IconButton
              className="ml-auto flex items-center"
              size="sm"
              round
              onClick={() => onRemove(item)}
              disabled={disabled}
              title="Remove"
            >
              <CloseIcon size={20} className="text-grey-500 rounded-full p-2 hover:bg-white/50" />
            </IconButton>
          </li>
        ))}
      </ul>
    </div>
  );
};
